import { useEffect, useRef } from 'react';

export const useOnOpen = (open: boolean, onOpen: () => void) => {
  const prevOpenRef = useRef(open);

  useEffect(() => {
    if (open && !prevOpenRef.current) {
      onOpen();
    }
    prevOpenRef.current = open;
  }, [open, onOpen]);
};
